import '@/bootstrap';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import Router from '@/router';
import { Toaster } from '@/components/ui/sonner';
import { AppProviders } from '@/lib/contexts/AppProviders';
import { usePageAttribute } from '@/lib/hooks/use-page-attribute';

function NavigationLogger() {
    const location = useLocation();
    const history = useRef([]);

    useEffect(() => {
        const entry = `${location.pathname}${location.search}${location.hash}`;
        history.current.push(entry);
        console.groupCollapsed(`[Nav] → ${entry}`);
        console.log('History:', [...history.current]);
        console.log('State:', location.state);
        console.groupEnd();
    }, [location]);

    return null;
}

function App() {
    usePageAttribute();

    return (
        <AppProviders>
            {import.meta.env.DEV && <NavigationLogger />}
            <Router />
            <Toaster />
        </AppProviders>
    );
}

const root = createRoot(document.getElementById('app'));
root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
);
